import { Injectable } from '@angular/core';
import { ErrorhandlingService } from './errorhandling.service';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { firstValueFrom, Observable, of } from 'rxjs';
import { DataService } from './data.service';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  constructor(private dataService: DataService, private tokenService: TokenStorageService, public matDialog: MatDialog) { }

  public objectComparisonFunction = function (option, value): boolean {
    if (option != null && value != null) {
      return option.id === value.id;
    } else {
      return false;
    }
  }

  public valueComparisonFunction = function (option, value): boolean {
    if (option != null && value != null) {
      return option === value;
    } else {
      return false;
    }
  }

  public async confirmDialog(title: string, message: string): Promise<boolean> {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = true;
    dialogConfig.id = "modal-component-confirm";
    dialogConfig.data = {
      title: title,
      message: message
    }

    dialogConfig.height = "205px";
    dialogConfig.width = "500px";
    const confirmDialog = this.matDialog.open(ConfirmDialogComponent, dialogConfig);

    const result = await firstValueFrom(confirmDialog.afterClosed());
    return result === true || result === 'true';
  }

  public parseICalExdatesToEpoch(exdateStr: string): Set<number> {
    if (!exdateStr) return new Set();

    const timestamps = exdateStr.split(',').map((dateStr) => {
      const formatted = dateStr.trim().replace(
        /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/,
        '$1-$2-$3T$4:$5:$6Z'
      );
      return new Date(formatted).getTime();
    });

    return new Set(timestamps);
  }

  public async hasFeature(expectedFeature: string): Promise<any> {
    const user = this.tokenService.getUser();
    if (!user) return of(false); 
      const feature = await firstValueFrom(this.dataService.getFeature(expectedFeature));
      if (feature) {
        return feature.enabled;
      } else {
        return of(false);
      }
    
  }

}
